module.exports = __webpack_public_path__ + "img/stvrt-novydvor.a6caabf3.jpg";